export enum JobType {
  exportOrganizations = 'exportOrganizations',
  importContact = 'importContact',
  importActivity = 'importActivity',
  importTiers = 'importPricingTiers',
  importProducts = 'importProducts',
  exportClockin = 'exportClockin',
  exportOvertime = 'exportOvertimeReport',
}

export interface ExportOrganizationSuccess {
  filename: string;
}

export type JobId = string;
export interface JobResponse {
  id: JobId;
  jobId: string;
  type: JobType;
  progress: number;
  isCompleted: boolean;
  canDismiss: boolean;
  isFailed: boolean;
  time: number;
  success?: ExportOrganizationSuccess;
  output?: JobImportOutput;
}

export type JobImportOutput = { [key: string]: ImportAlert[] };

export interface ImportAlert {
  type: 'warning' | 'error';
  message: string;
}
